// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Hgsrm","inputWrap":"styles_inputWrap__2aBre","input":"styles_input__3cAhl"};